import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { OutagesAndFaultsPage, OutagesAndFaultsProps } from "./OutagesAndFaultsPage";

export const EMPTY_PAGE_CONTENT: OutagesAndFaultsProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/outages-faults";

export const OutagesAndFaultsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<OutagesAndFaultsProps>("outages_and_faults", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <OutagesAndFaultsPage {...routeProps} {...content} />;
};
